<template>
  <v-app>
    <GlobalHeader v-if="showHeader"></GlobalHeader>
    <InvalidRoute v-if="invalidRouteFlag"></InvalidRoute>
    <router-view v-else />
    <GlobalFooter v-if="showHeader"></GlobalFooter>
    <CommonDialog></CommonDialog>
  </v-app>
</template>

<script>
import CommonDialog from "@/components/dialogs/CommonDialog.vue";
import { mapState } from "vuex";
import GlobalHeader from "@/components/global/GlobalHeader.vue";
import GlobalFooter from "@/components/global/GlobalFooter.vue";
import InvalidRoute from "@/views/InvalidRoute.vue";

export default {
  components: { InvalidRoute, GlobalFooter, GlobalHeader, CommonDialog },
  data: () => ({
    showHeader: false,
  }),
  computed: {
    ...mapState({
      window: (state) => state.window,
      tabFocused: (state) => state.tabFocused,
      invalidRouteFlag: (state) => state.invalidRoute,
    }),
  },
  created() {
    window.onfocus = () => {
      this.$store.commit("setTabFocused", true);
    };
    window.onblur = () => {
      this.$store.commit("setTabFocused", false);
    };
    makeVuetifyDraggable();
  },
  beforeCreate() {
    document.title = "Functionize";
  },
  mounted() {
    setTimeout(() => {
      this.showHeader = !this.$route.meta?.public;
    }, 1000);
    window.TAB_ACTIVE = true;
    window.addEventListener("focus", function () {
      window.TAB_ACTIVE = true;
    });

    window.addEventListener("blur", function () {
      window.TAB_ACTIVE = false;
    });
    // scrollBarShakeFix();
    document.getElementById("ref-icon").href = this.window.sitefavicon;
    setTimeout(() => {
      this.updateSiteTitle();
    }, 500);
  },
  methods: {
    updateSiteTitle() {
      if (document.title) {
        if (!document.title.toLowerCase().includes("functionize")) {
          document.title = document.title + " - " + this.window.sitetitle;
        }
      } else {
        document.title = this.window.sitetitle;
      }
    },
  },
  watch: {
    $route() {
      this.showHeader = !this.$route.meta?.public;
    },
  },
};

// function scrollBarShakeFix() {
//   document.addEventListener("keyup", function () {
//     const element = document.getElementsByTagName("body")[0];
//     const difference = window.innerHeight - element.clientHeight;
//     if (difference === 0) {
//       element.style.marginRight = "8px";
//     } else {
//       element.style.marginRight = "0";
//     }
//   });
// }

function makeVuetifyDraggable() {
  // make vuetify dialogs dragable
  let clicked = 0;
  let mouseStartX = null;
  let dilogStartX = null;
  let mouseStartY = null;
  let dilogStartY = null;
  let dilogWidth = null;
  let dilogHeight = null;
  let oldTransition = null;
  let dialog = null;
  /* Execute a function when the mouse button is pressed: */
  document.addEventListener("mousedown", dialogReady);
  /* And another function when the mouse button is released: */
  document.addEventListener("mouseup", dialogFinish);
  /* Or touched (for touch screens: */
  document.addEventListener("touchstart", dialogReady);
  /* And released (for touch screens: */
  document.addEventListener("touchend", dialogFinish);

  function dialogReady(e) {
    dialog = e.target.closest(".v-dialog.v-dialog--active");
    if (e.button === 0 && dialog != null && e.target.classList.contains("v-card__title")) {
      /* Prevent any other actions that may occur when moving over the image: */
      e.preventDefault();
      /* The dialog is now clicked and ready to move: */
      clicked = 1;
      mouseStartY = e.clientY;
      mouseStartX = e.clientX;
      let bounds = dialog.getBoundingClientRect();
      dilogStartY = bounds.top;
      dilogStartX = bounds.left;
      dilogWidth = bounds.width;
      dilogHeight = bounds.height;
      oldTransition = dialog.style.transition;
      dialog.style.position = "fixed";
      dialog.style.transition = "none";
      /* Execute a function when the dialog is moved: */
      document.addEventListener("mousemove", dialogMove);
      document.addEventListener("touchmove", dialogMove);
    }
  }

  function dialogFinish() {
    /* The dialog is no longer clicked: */
    clicked = 0;
    if (dialog && dialog.style) {
      dialog.style.transition = oldTransition;
    }
  }

  function dialogMove(e) {
    /* If the dialog is no longer clicked, exit this function: */
    if (clicked === 0) return false;
    const Y = dilogStartY + e.clientY - mouseStartY - 43;
    const X = dilogStartX + e.clientX - mouseStartX;
    if (Y > -20 && Y + dilogHeight + 30 < window.innerHeight) dialog.style.top = Y + "px";
    if (X > -20 && X + dilogWidth + 20 < window.innerWidth) dialog.style.left = X + "px";

    Array.from(document.getElementsByClassName("hide-on-drag")).map((el) => {
      el.style.display = "none";
    });
  }
}
</script>

<style lang="scss">
@import "assets/style/style.scss";
</style>
